<div class="loader-container" *ngIf="isLoading">
    <div class="loader"></div>
</div>

<div *ngIf="!isLoading">
    <app-title [country]="country" [cpaCode]="cpa" [cpaName]="cpaName" [locale]="locale"></app-title>

    <div class="flex-container">
        <div class="flex-row breadcrumb font-color-grey row-1">
            <span>
                <a routerLink="/dashboard" [queryParams]="{from: null, to: null}" queryParamsHandling="merge">
                    {{ 'T1' | translate : locale }}
                </a>
            </span>
            <span class="breadcrumb-arrow">></span>
            <span *ngIf="isRevenueScreen">{{ 'T2' | translate : locale }}</span>
            <span *ngIf="isShipmentScreen">{{ 'T3' | translate: locale }}</span>
        </div>

        <div class="flex-row border-bottom-2-red row-2">
            <div class="flex-row-item flex-row-item-align-bottom sub-title">
                <span *ngIf="isRevenueScreen">{{ 'T5' | translate : locale }}</span>
                <span *ngIf="isShipmentScreen">{{ 'T6' | translate : locale }}</span>
            </div>

            <div class="flex-row">
                <div class="flex-row-item flex-row-item-align-center">
                    <span>
                        <button (click)="onGetPreviousPeriod()" [disabled]="isPreviousButtonDisabled">
                            <i class="period-button-label fa fa-arrow-left" aria-hidden="true"></i>
                        </button>
                    </span>
                </div>

                <div class="flex-row-item flex-row-item-align-center flex-direction-column period-column">
                    <div class="font-color-grey">
                        <span *ngIf="isRevenueScreen">{{ 'T7' | translate : locale }}</span>
                        <span *ngIf="isShipmentScreen">{{ 'T8' | translate : locale }}</span>
                    </div>
                    <div class="period">{{ from | moment : 'D MMM' : locale }} - {{ to | moment : 'D MMM YYYY' : locale
                        }}
                    </div>
                </div>

                <div class="flex-row-item flex-row-item-align-center">
                    <span>
                        <button (click)="onGetNextPeriod()" [disabled]="isNextButtonDisabled">
                            <i class="period-button-label fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                    </span>
                </div>
            </div>

            <div class="flex-row-item flex-row-item-align-bottom">
                <span>
                    <button class="primary-button" (click)="onExport()">
                        <span class="button-label">
                            {{ 'T9' | translate : locale }}
                        </span>
                    </button>
                </span>
            </div>
        </div>

        <div class="flex-row ag-theme-material border-bottom-black row-3">
            <ag-grid-angular style="height: 100%; width: 100%;" [gridOptions]="gridOptions"
                [rowData]="shipments | async">
            </ag-grid-angular>
        </div>

        <div class="flex-row row-4">
            <div class="flex-row-item">
                <span [innerHTML]="'T31' | translate : locale : placeholders"
                    *ngIf="isRevenueScreen && allRowCount === displayedRowCount"></span>
                <span [innerHTML]="'T32' | translate : locale : placeholders"
                    *ngIf="isShipmentScreen && allRowCount === displayedRowCount"></span>
                <span [innerHTML]="'T31a' | translate : locale : placeholders"
                    *ngIf="isRevenueScreen && allRowCount !== displayedRowCount"></span>
                <span [innerHTML]="'T32a' | translate : locale : placeholders"
                    *ngIf="isShipmentScreen && allRowCount !== displayedRowCount"></span>
            </div>
            <div class="flex-row-item font-color-grey">
                <span>
                    {{ 'T34' | translate : locale : placeholders }}
                </span>
            </div>
        </div>
    </div>

</div>